import { render, staticRenderFns } from "./ServiceNumberDataOverseasUsageLineChart.vue?vue&type=template&id=45112cee&scoped=true&"
import script from "./ServiceNumberDataOverseasUsageLineChart.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberDataOverseasUsageLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45112cee",
  null
  
)

export default component.exports